import React from "react";
import { useNavigate } from "react-router-dom";
import { Briefcase, DollarSign, Clock, Shield, ArrowRight } from "lucide-react";
import { Button } from "../../../design-system/index.js";
import { cn } from "../../../design-system/index.js";

const BENEFICIOS = [
  { icon: Briefcase, title: "Encontre oportunidades", desc: "Acesse famílias verificadas que precisam de cuidados profissionais." },
  { icon: DollarSign, title: "Renda garantida", desc: "Pagamentos seguros e pontuais diretamente pela plataforma." },
  { icon: Clock, title: "Horários flexíveis", desc: "Trabalhe nos dias e horários que combinam com você." },
  { icon: Shield, title: "Perfil verificado", desc: "Seu perfil com certificação Tesourinhos aumenta sua credibilidade." },
];

export default function BabysittersPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-warm-50 py-16">
      <div className="mx-auto max-w-4xl px-4 sm:px-6">

        {/* Hero */}
        <div className="text-center mb-14">
          <span className="inline-block rounded-full bg-slate-blue-400/12 px-3 py-1 text-xs font-semibold text-slate-blue-400 mb-4">
            Para babás
          </span>
          <h1 className={cn(
            "font-heading text-4xl sm:text-5xl font-bold",
            "text-warm-900 mb-4"
          )}>
            Trabalhe com famílias{" "}
            <span className="text-slate-blue-400">de confiança</span>
          </h1>
          <p className="text-lg text-warm-600 max-w-xl mx-auto leading-relaxed">
            Conecte-se com famílias verificadas, ganhe mais e trabalhe com segurança.
          </p>
        </div>

        {/* Benefícios */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-14">
          {BENEFICIOS.map(({ icon: Icon, title, desc }) => (
            <div key={title} className="flex gap-4 bg-white rounded-2xl p-5 shadow-sm border border-warm-100">
              <div className="shrink-0 flex h-10 w-10 items-center justify-center rounded-xl bg-slate-blue-400/12">
                <Icon size={20} className="text-slate-blue-400" />
              </div>
              <div>
                <h3 className="font-semibold text-warm-900 mb-1">{title}</h3>
                <p className="text-sm text-warm-500 leading-relaxed">{desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="bg-gradient-to-br from-slate-blue-400 to-[#6b7fa8] rounded-3xl p-8 text-center text-white">
          <h2 className="font-heading text-2xl sm:text-3xl font-bold mb-3">Faça parte da rede Tesourinhos!</h2>
          <p className="text-white/80 mb-6 max-w-sm mx-auto">Cadastro gratuito. Comece a receber oportunidades hoje.</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              variant="secondary"
              size="lg"
              className="rounded-full bg-white px-7 py-3 font-bold text-slate-blue-400 shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all"
              onClick={() => navigate("/profile-selection?type=babysitter")}
            >
              Criar conta grátis <ArrowRight size={16} />
            </Button>
            <Button
              variant="ghost"
              size="lg"
              className="rounded-full border-2 border-white/60 px-7 py-3 font-bold text-white hover:bg-white/10"
              onClick={() => navigate("/login")}
            >
              Já tenho conta
            </Button>
          </div>
        </div>

      </div>
    </div>
  );
}
